export const AUDIT_OUTPUT_TYPES = [
  { value: 'certificate', label: 'Certificate' },
  { value: 'report', label: 'Report' },
  { value: 'opinion', label: 'Opinion' },
];

export const AUDIT_OUTPUT_SITE_MODES = [
  { value: 'single-site', label: 'Single Site' },
  { value: 'multi-site', label: 'Multi Site' },
];

export const DEFAULT_TEMPLATE_CONFIG = {
  page: {
    backgroundColor: '#ffffff',
    backgroundImage: '',
    textColor: '#1f2937',
    accentColor: '#0f766e',
    paddingTop: 20,
    paddingRight: 18,
    paddingBottom: 18,
    paddingLeft: 18,
  },
  logo: {
    enabled: true,
    dataUrl: '',
    x: 18,
    y: 14,
    width: 28,
    height: 28,
  },
  header: {
    enabled: true,
    title: '{{organization.name}}',
    subtitle: '{{organization.tagline}}',
    align: 'center',
  },
  footer: {
    enabled: true,
    leftText: '{{organization.name}}',
    rightText: 'Page {{page.current}} / {{page.total}}',
    certificateText: 'This certificate is issued according to the agreed Certification Agreement of certification services that can be accessed at https://www.cbqaglobal.com/iso-certification-service-agreement. This certificate\'s validity is subject to the continued satisfactory maintenance of the Organisation\'s Management System. Certificate could be validated by clicking on the link provided above (on the left-hand side) or by scanning both codes provided above (on the middle & right-hand side) with a smartphone. Office Address: South Quarter Tower A, 17th floor Unit B2-C1, Jl. R.A. Kartini Kav. 8, Cilandak Barat, Cilandak, Jakarta Selatan 12430.',
  },
  certificate: {
    baseTemplateKey: 'auto',
    title: 'CERTIFICATE OF REGISTRATION',
    subtitle: 'T h i s   i s   t o   c e r t i f y ,   t h a t :',
    statement: '',
    companyName: '{{project.companyName}}',
    companyAddress: '{{project.address}}',
    certificateNumberLabel: 'Certificate Number',
    decisionLabel: 'Certification Decision',
    standardsIntro: 'has implemented and maintains a management system that complies with:',
    standardsText: '{{certificate.standards}}',
    scopeLabel: 'Scope of Certification',
    scopeText: '{{certificate.scopeStatement}}',
    verificationLabel: 'Verification of Scope',
    verificationText: '{{certificate.verificationOfScope}}',
    dates: [
      { label: 'Initial Certification Date', value: '{{certificate.initialDate}}' },
      { label: 'Latest Certification Date', value: '{{certificate.latestCertificationDate}}' },
      { label: 'Issue Date', value: '{{certificate.issueDate}}' },
      { label: 'Expired Date', value: '{{certificate.expiredDate}}' },
    ],
    signatureName: '{{certificate.signatureName}}',
    signatureTitle: '{{certificate.signatureTitle}}',
    signatureImage: {
      enabled: false,
      dataUrl: '',
      width: 34,
      height: 18,
      preserveAspectRatio: true,
    },
    coordinateLayout: {
      enabled: false,
      fields: {},
    },
    standardLogo: {
      enabled: false,
      dataUrl: '',
      x: 150,
      y: 20,
      width: 45,
      height: 45,
    },
    accreditationLogos: {
      iaf: {
        enabled: false,
        dataUrl: '',
        x: 148,
        y: 245,
        width: 42,
        height: 23,
      },
      kan: {
        enabled: false,
        dataUrl: '',
        x: 148,
        y: 275,
        width: 42,
        height: 27,
      },
    },
    remarks: '{{certificate.remarks}}',
  },
  report: {
    title: 'AUDIT REPORT',
    subtitle: '{{project.projectCode}}',
    intro: 'This report summarizes the audit outcome for {{project.companyName}}.',
    body: '{{report.summaryNarrative}}',
    conclusionTitle: 'Conclusion',
    conclusionText: '{{report.conclusion}}',
    recommendationTitle: 'Recommendations',
    recommendationText: '{{report.recommendations}}',
  },
  opinion: {
    title: 'CERTIFICATION OPINION',
    subtitle: '{{project.projectCode}}',
    intro: 'Certification decision summary for {{project.companyName}}.',
    decisionLabel: 'Decision',
    decisionValue: '{{certificate.certificationDecision}}',
    body: '{{certificate.remarks}}',
  },
  multiSite: {
    title: 'Certified Sites',
    intro: 'The following sites are covered by this certificate.',
    footerNote: '{{certificate.siteCount}} site(s) included in this scope.',
    includePrimarySiteOnAppendix: true,
  },
};

export const buildDefaultAuditOutputTemplate = (overrides = {}) => ({
  templateName: '',
  description: '',
  outputType: 'certificate',
  siteMode: 'single-site',
  standards: [],
  config: {
    ...DEFAULT_TEMPLATE_CONFIG,
    ...overrides?.config,
    page: {
      ...DEFAULT_TEMPLATE_CONFIG.page,
      ...overrides?.config?.page,
    },
    logo: {
      ...DEFAULT_TEMPLATE_CONFIG.logo,
      ...overrides?.config?.logo,
    },
    header: {
      ...DEFAULT_TEMPLATE_CONFIG.header,
      ...overrides?.config?.header,
    },
    footer: {
      ...DEFAULT_TEMPLATE_CONFIG.footer,
      ...overrides?.config?.footer,
    },
    certificate: {
      ...DEFAULT_TEMPLATE_CONFIG.certificate,
      ...overrides?.config?.certificate,
      signatureImage: {
        ...DEFAULT_TEMPLATE_CONFIG.certificate.signatureImage,
        ...overrides?.config?.certificate?.signatureImage,
      },
      coordinateLayout: {
        ...DEFAULT_TEMPLATE_CONFIG.certificate.coordinateLayout,
        ...overrides?.config?.certificate?.coordinateLayout,
      },
      dates: Array.isArray(overrides?.config?.certificate?.dates)
        ? overrides.config.certificate.dates
        : DEFAULT_TEMPLATE_CONFIG.certificate.dates,
    },
    report: {
      ...DEFAULT_TEMPLATE_CONFIG.report,
      ...overrides?.config?.report,
    },
    opinion: {
      ...DEFAULT_TEMPLATE_CONFIG.opinion,
      ...overrides?.config?.opinion,
    },
    multiSite: {
      ...DEFAULT_TEMPLATE_CONFIG.multiSite,
      ...overrides?.config?.multiSite,
    },
  },
  ...overrides,
});
